export default "__VITE_ASSET__DlWrI1z___"